import axiosClient from "@/api/common/axiosClient.ts";
import { Prize } from "@/types/prize.ts";

export const getDrawPrizes = ({ id }: { id?: string | number }) => {
  return axiosClient.get<Prize[]>(`draws/${id}/prizes/`);
};
